import {gql} from 'apollo-boost'

export const GET_PERIOD = gql`
  query getPeriod($id: ID!) {
    getPeriod(
      id: $id
    ){
      id
      sequence
      isChoose
      term
      year
      name
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }  }
`

export const GET_PERIODS = gql`
  query getPeriods {
    getPeriods{
      id
      sequence
      isChoose
      term
      year
      name
      nameTh
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_PERIOD = gql`
  mutation createPeriod($payload: PeriodInput!) {
    createPeriod(
      payload: $payload
    ){
      id
      sequence
      isChoose
      term
      year
      name
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_PERIOD = gql`
  mutation updatePeriod($id: ID!, $payload: PeriodInput!) {
    updatePeriod(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      term
      year
      name
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_PERIOD = gql`
  mutation deletePeriod($id: ID!) {
    deletePeriod(
      id: $id
    ) {
      id
    }
  }
`

export const GET_DEGREE = gql`
  query getDegree($id: ID!) {
    getDegree(
      id: $id
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_DEGREES = gql`
  query getDegrees {
    getDegrees{
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_DEGREE_OPTIONS = gql`
  query getDegrees {
    getDegrees{
      id
      sequence
      isChoose
      nameTh
      status
    }
  }
`

export const CREATE_DEGREE = gql`
  mutation createDegree($payload: DegreeInput!) {
    createDegree(
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_DEGREE = gql`
  mutation updateDegree($id: ID!, $payload: DegreeInput!) {
    updateDegree(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_DEGREE = gql`
  mutation deleteDegree($id: ID!) {
    deleteDegree(
      id: $id
    ) {
      id
    }
  }
`

export const GET_PROJECT = gql`
  query getProject($id: ID!) {
    getProject(
      id: $id
    ){
      id
      sequence
      isChoose
      projectNo
      nameTh
      nameEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_PROJECTS = gql`
  query getProjects {
    getProjects{
      id
      sequence
      isChoose
      projectNo
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_PROJECTS_OPTIONS = gql`
  query getProjects {
    getProjects{
      id
      sequence
      projectNo
      isChoose
      nameTh
      status
    }
  }
`

export const GET_SEARCH_PROJECTS = gql`
  query getProjects {
    getProjects{
      id
      sequence
      isChoose
      projectNo
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_PROJECT = gql`
  mutation createProject($payload: ProjectInput!) {
    createProject(
      payload: $payload
    ){
      id
      sequence
      isChoose
      projectNo
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_PROJECT = gql`
  mutation updateProject($id: ID!, $payload: ProjectInput!) {
    updateProject(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      projectNo
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_PROJECT = gql`
  mutation deleteProject($id: ID!) {
    deleteProject(
      id: $id
    ) {
      id
    }
  }
`

export const GET_CAMPUS = gql`
  query getCampus($id: ID!) {
    getCampus(
      id: $id
    ){
      id
      projectId
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
      ## custom field
      projectName
    }
  }
`

export const GET_CAMPUSES = gql`
  query getCampuses {
    getCampuses{
      id
      projectId
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
      ## custom field
      projectName
    }
  }
`

export const GET_CAMPUSES_OPTIONS = gql`
  query getCampuses {
    getCampuses{
      id
      projectId
      sequence
      isChoose
      nameTh
      status
      ## custom field
      projectName
    }
  }
`

export const CREATE_CAMPUS = gql`
  mutation createCampus($payload: CampusInput!) {
    createCampus(
      payload: $payload
    ){
      id
      projectId
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
      ## custom field
      projectName
    }
  }
`

export const UPDATE_CAMPUS = gql`
  mutation updateCampus($id: ID!, $payload: CampusInput!) {
    updateCampus(
      id: $id
      payload: $payload
    ){
      id
      projectId
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
      ## custom field
      projectName
    }
  }
`

export const DELETE_CAMPUS = gql`
  mutation deleteCampus($id: ID!) {
    deleteCampus(
      id: $id
    ) {
      id
    }
  }
`

export const GET_FACULTY = gql`
  query getFaculty($id: ID!) {
    getFaculty(
      id: $id
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_FACULTIES = gql`
  query getFaculties {
    getFaculties{
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_FACULTY = gql`
  mutation createFaculty($payload: FacultyInput!) {
    createFaculty(
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_FACULTY = gql`
  mutation updateFaculty($id: ID!, $payload: FacultyInput!) {
    updateFaculty(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_FACULTY = gql`
  mutation deleteFaculty($id: ID!) {
    deleteFaculty(
      id: $id
    ) {
      id
    }
  }
`

export const GET_CURRICULUM = gql`
  query getCurriculum($id: ID!) {
    getCurriculum(
      id: $id
    ){
      id
      curriculumNo
      sequence
      isChoose
      nameTh
      nameEn
      faculty{
        id
        nameTh
        nameEn
        status
        createdBy{
          id
        }
        updatedBy{
          id
        }
      }
      curriculumDetails{
        id
        loanType
        curriculumPeriod
        maximumLoanAmount
        contractPeriod
        paymentAmount
        status
        createdAt
        createdBy{
          id
        }
      }
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_CURRICULUMS = gql`
  query getCurriculums {
    getCurriculums{
      id
      curriculumNo
      sequence
      isChoose
      nameTh
      nameEn
      faculty{
        id
        nameTh
        nameEn
        status
        createdBy{
          id
        }
        updatedBy{
          id
        }
      }
      curriculumDetails{
        id
        loanType
        curriculumPeriod
        maximumLoanAmount
        contractPeriod
        paymentAmount
        status
        createdAt
        createdBy{
          id
        }
      }
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_CURRICULUM_OPTIONS = gql`
  query getCurriculums {
    getCurriculums{
      id
      curriculumNo
      sequence
      isChoose
      nameTh
      status
      faculty{
        id
        nameTh
      }
    }
  }
`

export const GET_SEARCH_CURRICULUMS = gql`
  query getCurriculums {
    getCurriculums{
      id
      curriculumNo
      sequence
      isChoose
      nameTh
      nameEn
      faculty{
        id
        nameTh
        nameEn
        status
        createdBy{
          id
        }
        updatedBy{
          id
        }
      }
      curriculumDetails{
        id
        loanType
        curriculumPeriod
        maximumLoanAmount
        contractPeriod
        paymentAmount
        status
        createdAt
        createdBy{
          id
        }
      }
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_CURRICULUM = gql`
  mutation createCurriculum($payload: CurriculumInput!) {
    createCurriculum(
      payload: $payload
    ){
      id
      curriculumNo
      sequence
      isChoose
      nameTh
      nameEn
      faculty{
        id
        nameTh
        nameEn
        status
        createdBy{
          id
        }
        updatedBy{
          id
        }
      }
      curriculumDetails{
        id
        loanType
        curriculumPeriod
        maximumLoanAmount
        contractPeriod
        paymentAmount
        status
        createdAt
        createdBy{
          id
        }
      }
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_CURRICULUM = gql`
  mutation updateCurriculum($id: ID!, $payload: CurriculumInput!) {
    updateCurriculum(
      id: $id
      payload: $payload
    ){
      id
      curriculumNo
      sequence
      isChoose
      nameTh
      nameEn
      faculty{
        id
        nameTh
        nameEn
        status
        createdBy{
          id
        }
        updatedBy{
          id
        }
      }
      curriculumDetails{
        id
        loanType
        curriculumPeriod
        maximumLoanAmount
        contractPeriod
        paymentAmount
        status
        createdAt
        createdBy{
          id
        }
      }
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_CURRICULUM = gql`
  mutation deleteCurriculum($id: ID!) {
    deleteCurriculum(
      id: $id
    ) {
      id
    }
  }
`

export const GET_CURRICULUM_EXTERNAL = gql`
  query getCurriculumExternal($id: ID!) {
    getCurriculumExternal(
      id: $id
    ){
      id
      sequence
      isChoose
      project{
        id
        nameTh
      }
      curriculum{
        id
        nameTh
      }
      campusId
      campusName
      facultyId
      facultyName
      degreeId
      degreeName
      curriculumCode
      curriculumName
      periodYear
      periodTerm
      regularYear
      startDate
      graduationDate
      tuitionFee
      registrationFee
      costOfLivingFee
      periods
      periodAmount
      periodAmountWithOutRegistrationFee
      lastPeriodAmount
      lastPeriodAmountWithOutRegistrationFee
      notice
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_CURRICULUM_EXTERNALS = gql`
  query getCurriculumExternals {
    getCurriculumExternals{
      id
      sequence
      isChoose
      project{
        id
        nameTh
      }
      curriculum{
        id
        nameTh
        faculty{
          id
          nameTh
        }
      }
      campusId
      campusName
      facultyId
      facultyName
      degreeId
      degreeName
      curriculumCode
      curriculumName
      periodYear
      periodTerm
      regularYear
      startDate
      graduationDate
      tuitionFee
      registrationFee
      costOfLivingFee
      contractFee
      periods
      periodAmount
      periodAmountWithOutRegistrationFee
      lastPeriodAmount
      lastPeriodAmountWithOutRegistrationFee
      notice
      suretyRequired
      suretyFullRequired
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_CURRICULUM_EXTERNALS_ODER_BY_SET_CURRICULUM = gql`
  query getCurriculumExternalsEnabled {
    getCurriculumExternalsEnabled{
      id
      sequence
      isChoose
      project{
        id
        nameTh
      }
      curriculum{
        id
        nameTh
      }
      campusId
      campusName
      facultyId
      facultyName
      degreeId
      degreeName
      curriculumCode
      curriculumName
      periodYear
      periodTerm
      regularYear
      startDate
      graduationDate
      tuitionFee
      registrationFee
      costOfLivingFee
      periods
      periodAmount
      periodAmountWithOutRegistrationFee
      lastPeriodAmount
      lastPeriodAmountWithOutRegistrationFee
      notice
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_CURRICULUM_EXTERNAL = gql`
  mutation createCurriculumExternal($payload: CurriculumExternalInput!) {
    createCurriculumExternal(
      payload: $payload
    ){
      id
      sequence
      isChoose
      project{
        id
        nameTh
      }
      curriculum{
        id
        nameTh
      }
      campusId
      campusName
      facultyId
      facultyName
      degreeId
      degreeName
      curriculumCode
      curriculumName
      periodYear
      periodTerm
      regularYear
      startDate
      graduationDate
      tuitionFee
      registrationFee
      costOfLivingFee
      periods
      periodAmount
      periodAmountWithOutRegistrationFee
      lastPeriodAmount
      lastPeriodAmountWithOutRegistrationFee
      notice
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_CURRICULUM_EXTERNAL = gql`
  mutation updateCurriculumExternal($id: ID!, $payload: CurriculumExternalInput!) {
    updateCurriculumExternal(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      project{
        id
        nameTh
      }
      curriculum{
        id
        nameTh
      }
      campusId
      campusName
      facultyId
      facultyName
      degreeId
      degreeName
      curriculumCode
      curriculumName
      periodYear
      periodTerm
      regularYear
      startDate
      graduationDate
      tuitionFee
      registrationFee
      costOfLivingFee
      periods
      periodAmount
      periodAmountWithOutRegistrationFee
      lastPeriodAmount
      lastPeriodAmountWithOutRegistrationFee
      notice
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_CURRICULUM_EXTERNAL_API = gql`
  mutation updateCurriculumExternalApi {
    updateCurriculumExternalApi{
      result
      msg
    }
  }
`

export const DELETE_CURRICULUM_EXTERNAL = gql`
  mutation deleteCurriculumExternal($id: ID!) {
    deleteCurriculumExternal(
      id: $id
    ) {
      id
    }
  }
`

export const GET_PREFIX = gql`
  query getPrefix($id: ID!) {
    getPrefix(
      id: $id
    ){
      id
      sequence
      isChoose
      nameTh
      nameShortTh
      nameEn
      nameShortEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_PREFIXES = gql`
  query getPrefixes {
    getPrefixes{
      id
      sequence
      isChoose
      nameTh
      nameShortTh
      nameEn
      nameShortEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_PREFIX_OPTIONS = gql`
  query getPrefixes {
    getPrefixes{
      id
      sequence
      isChoose
      nameTh
      status
    }
  }
`

export const CREATE_PREFIX = gql`
  mutation createPrefix($payload: PrefixInput!) {
    createPrefix(
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameShortTh
      nameEn
      nameShortEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_PREFIX = gql`
  mutation updatePrefix($id: ID!, $payload: PrefixInput!) {
    updatePrefix(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameShortTh
      nameEn
      nameShortEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_PREFIX = gql`
  mutation deletePrefix($id: ID!) {
    deletePrefix(
      id: $id
    ) {
      id
    }
  }
`

export const GET_RELATIONSHIP = gql`
  query getRelationship($id: ID!) {
    getRelationship(
      id: $id
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_RELATIONSHIPS = gql`
  query getRelationships {
    getRelationships{
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_RELATIONSHIP_OPTIONS = gql`
  query getRelationships {
    getRelationships{
      id
      sequence
      isChoose
      nameTh
      status
    }
  }
`

export const CREATE_RELATIONSHIP = gql`
  mutation createRelationship($payload: RelationshipInput!) {
    createRelationship(
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_RELATIONSHIP = gql`
  mutation updateRelationship($id: ID!, $payload: RelationshipInput!) {
    updateRelationship(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_RELATIONSHIP = gql`
  mutation deleteRelationship($id: ID!) {
    deleteRelationship(
      id: $id
    ) {
      id
    }
  }
`

export const GET_NATIONALITY = gql`
  query getNationality($id: ID!) {
    getNationality(
      id: $id
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_NATIONALITIES = gql`
  query getNationalities {
    getNationalities{
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_NATIONALITY = gql`
  mutation createNationality($payload: NationalityInput!) {
    createNationality(
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_NATIONALITY = gql`
  mutation updateNationality($id: ID!, $payload: NationalityInput!) {
    updateNationality(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_NATIONALITY = gql`
  mutation deleteNationality($id: ID!) {
    deleteNationality(
      id: $id
    ) {
      id
    }
  }
`

export const GET_RACE = gql`
  query getRace($id: ID!) {
    getRace(
      id: $id
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_RACES = gql`
  query getRaces {
    getRaces{
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_RACE = gql`
  mutation createRace($payload: RaceInput!) {
    createRace(
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_RACE = gql`
  mutation updateRace($id: ID!, $payload: RaceInput!) {
    updateRace(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_RACE = gql`
  mutation deleteRace($id: ID!) {
    deleteRace(
      id: $id
    ) {
      id
    }
  }
`

export const GET_RELIGION = gql`
  query getReligion($id: ID!) {
    getReligion(
      id: $id
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_RELIGIONS = gql`
  query getReligions {
    getReligions{
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_RELIGION = gql`
  mutation createReligion($payload: ReligionInput!) {
    createReligion(
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_RELIGION = gql`
  mutation updateReligion($id: ID!, $payload: ReligionInput!) {
    updateReligion(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_RELIGION = gql`
  mutation deleteReligion($id: ID!) {
    deleteReligion(
      id: $id
    ) {
      id
    }
  }
`

export const GET_OCCUPATION = gql`
  query getOccupation($id: ID!) {
    getOccupation(
      id: $id
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_OCCUPATIONS = gql`
  query getOccupations {
    getOccupations{
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_OCCUPATION = gql`
  mutation createOccupation($payload: OccupationInput!) {
    createOccupation(
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_OCCUPATION = gql`
  mutation updateOccupation($id: ID!, $payload: OccupationInput!) {
    updateOccupation(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_OCCUPATION = gql`
  mutation deleteOccupation($id: ID!) {
    deleteOccupation(
      id: $id
    ) {
      id
    }
  }
`

export const GET_SIGNER = gql`
  query getSigner($id: ID!) {
    getSigner(
      id: $id
    ){
      id
      sequence
      isChoose
      prefix{
        id
        nameTh
      }
      fullName
      name
      surname
      position
      phone
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_SIGNERS = gql`
  query getSigners {
    getSigners{
      id
      sequence
      isChoose
      fullName
      position
      phone
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_SIGNER_OPTIONS = gql`
  query getSigners {
    getSigners{
      id
      fullName
      position
      status
    }
  }
`

export const CREATE_SIGNER = gql`
  mutation createSigner($payload: SignerInput!) {
    createSigner(
      payload: $payload
    ){
      id
      sequence
      isChoose
      prefix{
        id
        nameTh
      }
      name
      surname
      position
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_SIGNER = gql`
  mutation updateSigner($id: ID!, $payload: SignerInput!) {
    updateSigner(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      prefix{
        id
        nameTh
      }
      name
      surname
      position
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_SIGNER = gql`
  mutation deleteSigner($id: ID!) {
    deleteSigner(
      id: $id
    ) {
      id
    }
  }
`

export const GET_NOTIFICATION_TEMPLATE = gql`
  query getNotificationTemplate($id: ID!) {
    getNotificationTemplate(
      id: $id
    ){
      id
      sequence
      isChoose
      name
      title
      description
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_NOTIFICATION_TEMPLATES = gql`
  query getNotificationTemplates {
    getNotificationTemplates{
      id
      sequence
      isChoose
      name
      title
      description
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const GET_NOTIFICATION_TEMPLATE_OPTIONS = gql`
  query getNotificationTemplates {
    getNotificationTemplates{
      id
      sequence
      isChoose
      name
      title
      description
      status
    }
  }
`

export const CREATE_NOTIFICATION_TEMPLATE = gql`
  mutation createNotificationTemplate($payload: NotificationTemplateInput!) {
    createNotificationTemplate(
      payload: $payload
    ){
      id
      sequence
      isChoose
      name
      title
      description
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_NOTIFICATION_TEMPLATE = gql`
  mutation updateNotificationTemplate($id: ID!, $payload: NotificationTemplateInput!) {
    updateNotificationTemplate(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      name
      title
      description
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_NOTIFICATION_TEMPLATE = gql`
  mutation deleteNotificationTemplate($id: ID!) {
    deleteNotificationTemplate(
      id: $id
    ) {
      id
    }
  }
`

export const GET_EDUCATION_STATUS = gql`
  query getEducationStatus($id: ID!) {
    getEducationStatus(
      id: $id
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdAt
      updatedAt
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const CREATE_EDUCATION_STATUS = gql`
  mutation createEducationStatus($payload: EducationStatusInput!) {
    createEducationStatus(
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const UPDATE_EDUCATION_STATUS = gql`
  mutation updateEducationStatus($id: ID!, $payload: EducationStatusInput!) {
    updateEducationStatus(
      id: $id
      payload: $payload
    ){
      id
      sequence
      isChoose
      nameTh
      nameEn
      status
      createdBy{
        id
      }
      updatedBy{
        id
      }
    }
  }
`

export const DELETE_EDUCATION_STATUS = gql`
  mutation deleteEducationStatus($id: ID!) {
    deleteEducationStatus(
      id: $id
    ) {
      id
    }
  }
`

export const UPDATE_SET_DEFAULT_MASTER = gql`
  mutation updateSetDefaultMaster($id: ID!, $payload: SetDefaultMasterInput!) {
    updateSetDefaultMaster(
      id: $id
      payload: $payload
    ){
      count
    }
  }
`

export const GET_DEBT_RESTRUCTURE_POLICY = gql`
  query getDebtRestructurePolicy($id: ID!) {
    getDebtRestructurePolicy(id: $id) {
      id
      effectiveDate
      name
      description

      status
      createdAt
      updatedAt
      createdBy {
        id
      }
      updatedBy {
        id
      }
      measures {
        id
        orderNumber
        name
        description
        subMeasures {
          id
          orderNumber
          name
          description
        }
      }
    }
  }
`;

export const GET_DEBT_RESTRUCTURE_POLICIES = gql`
  query getDebtRestructurePolicies {
    getDebtRestructurePolicies {
      id
      name
      description
      effectiveDate
      status
      createdAt
      updatedAt
      createdBy {
        id
      }
      updatedBy {
        id
      }
      measureCount
      subMeasureCount
    }
  }
`;

export const CREATE_DEBT_RESTRUCTURE_POLICY = gql`
  mutation createDebtRestructurePolicy($payload: DebtRestructurePolicyInput!) {
    createDebtRestructurePolicy(payload: $payload) {
      id
      name
      description
      effectiveDate
      status
      measures {
        id
        orderNumber
        name
        description
        subMeasures {
          id
          orderNumber
          name
          description
        }
      }
    }
  }
`;

export const UPDATE_DEBT_RESTRUCTURE_POLICY = gql`
  mutation updateDebtRestructurePolicy($id: ID!, $payload: DebtRestructurePolicyInput!) {
    updateDebtRestructurePolicy(id: $id, payload: $payload) {
      id
      name
      description
      effectiveDate
      status
      measures {
        id
        orderNumber
        name
        description
        subMeasures {
          id
          orderNumber
          name
          description
        }
      }
    }
  }
`;

export const DELETE_DEBT_RESTRUCTURE_POLICY = gql`
  mutation deleteDebtRestructurePolicy($id: ID!) {
    deleteDebtRestructurePolicy(id: $id) {
      id
    }
  }
`;

export const GET_MEASURE = gql`
  query getMeasure($id: ID!) {
    getMeasure(id: $id) {
      id
      debtRestructurePolicyId
      orderNumber
      name
      description
      subMeasures {
        id
        orderNumber
        name
        description
      }
    }
  }
`;

export const GET_MEASURES = gql`
  query getMeasures {
    getMeasures {
      id
      debtRestructurePolicyId
      orderNumber
      name
      description
    }
  }
`;

export const CREATE_MEASURE = gql`
  mutation createMeasure($payload: MeasureInput!) {
    createMeasure(payload: $payload) {
      id
      name
      description
    }
  }
`;

export const UPDATE_MEASURE = gql`
  mutation updateMeasure($id: ID!, $payload: MeasureInput!) {
    updateMeasure(id: $id, payload: $payload) {
      id
      name
      description
    }
  }
`;

export const DELETE_MEASURE = gql`
  mutation deleteMeasure($id: ID!) {
    deleteMeasure(id: $id) {
      id
    }
  }
`;

export const GET_SUB_MEASURE = gql`
  query getSubMeasure($id: ID!) {
    getSubMeasure(id: $id) {
      id
      measureId
      orderNumber
      name
      description
      minTermMonths
      maxTermMonths
      extraCondition
    }
  }
`;

export const GET_SUB_MEASURES = gql`
  query getSubMeasures {
    getSubMeasures {
      id
      measureId
      orderNumber
      name
      description
    }
  }
`;

export const GET_SUB_MEASURES_OPTIONS = gql`
  query getSubMeasures {
    getSubMeasures{
      id
      measureId
      orderNumber
      name
      description
      optionName
    }
  }
`

export const CREATE_SUB_MEASURE = gql`
  mutation createSubMeasure($payload: SubMeasureInput!) {
    createSubMeasure(payload: $payload) {
      id
      orderNumber
      name
      description
    }
  }
`;

export const UPDATE_SUB_MEASURE = gql`
  mutation updateSubMeasure($id: ID!, $payload: SubMeasureInput!) {
    updateSubMeasure(id: $id, payload: $payload) {
      id
      orderNumber
      name
      description
    }
  }
`;

export const DELETE_SUB_MEASURE = gql`
  mutation deleteSubMeasure($id: ID!) {
    deleteSubMeasure(id: $id) {
      id
    }
  }
`;
